import { createStore } from 'vuex';

import coachesModule from './modules/coaches/index.js';
import requestsModule from './modules/requests/index.js';
import usersModule from './modules/users/index.js';
import ordersModule from './modules/orders/index.js';
import positionsModule from './modules/positions/index.js';
import tradesModule from './modules/trades/index.js'; 
import createPersistedState from 'vuex-persistedstate'
import snackbar from './modules/snackbar' 
import strategy from './modules/strategy'   
import indicators from './modules/indicators'
import portfolio from './modules/portfolio'
import coveredcall from './modules/coveredcall'
import utils from './modules/utils'

const store = createStore({
  modules: {
    coaches: coachesModule,
    requests: requestsModule,
    users: usersModule,
    orders: ordersModule,
    positions: positionsModule,
    trades: tradesModule,
    snackbar: snackbar,
    strategy: strategy ,
    indicators: indicators,
    portfolio:portfolio,
    coveredcall: coveredcall,
    utils: utils
  },
  plugins: [createPersistedState({
    paths: ['users']
  })],
  state() {
    return {
      userId: 'c3'
    };
  },
  getters: {
    userId(state) {
      return state.userId;
    }
  }
});

export default store;